<template lang='pug'>
//- Side-Effect-Analysis
div(:class='$style[`cc-side-effect-analysis`]')
  div(:class='$style[`cc-side-effect-analysis-wrap`]')
    //- div.font-bold(:class='$style[`cc-side-effect-analysis-banner`]')
    //-   span.no-wrap 健檢分析紀錄
    header.font-bold(:class='$style[`cc-side-effect-analysis-banner`]') 健檢分析紀錄

    div(v-if='showLoading' :class='$style[`cc-side-effect-analysis-container`]')
      div(:class='$style[`cc-side-effect-analysis-loading`]')
        IconLoading(:size='30' :color='`#b1b1b1`')

    div(v-else :class='$style[`cc-side-effect-analysis-container`]')
      div(v-if='analysisEmpty' :class='$style[`cc-side-effect-analysis-empty`]')
        span(:class='$style[`cc-side-effect-analysis-empty-text`]') 查無資料

      ul(v-else :class='$style[`cc-side-effect-analysis-ul`]')
        li(v-for='items, index in analysisData' :key='index' :class='[$style[`cc-side-effect-analysis-li`], $style[items.category === `prediction` ? `cc-prediction` : ``]]')
          button(
            tabindex='0'
            aria-label='瀏覽健檢分析報告'
            :class='$style[`cc-side-effect-analysis-btn`]'
            @click='handleClickShowAnalysisDetail(items)')
            div(:class='$style[`cc-side-effect-analysis-li-left`]')

              article(v-if='items.start_date && items.end_date' :class='$style[`cc-side-effect-analysis-period`]')
                span.font-medium(:class='$style[`cc-side-effect-analysis-date`]') {{ items.start_date }}
                span.font-medium(:class='$style[`cc-side-effect-analysis-dash`]') -
                span.font-medium(:class='$style[`cc-side-effect-analysis-date`]') {{ items.end_date }}
                mark.font-medium(:class='$style[`cc-side-effect-analysis-mark`]') 預測

              article(v-else :class='$style[`cc-side-effect-analysis-period`]')
                span.font-medium(:class='$style[`cc-side-effect-analysis-date`]') {{ items.start_date }}

              article(:class='$style[`cc-side-effect-analysis-broadcast`]')
                span.font-medium {{ items.broadcast }}

            div(:class='$style[`cc-side-effect-analysis-li-right`]')
              div(:class='$style[`cc-side-effect-analysis-icon`]')
                IconSearch(:size='18' :color='`#98a1a1`')

      //- LazyLoad
      infinite-loading(:identifier='infiniteId' @infinite='infiniteHandler')
        div(slot='spinner')
          IconLoading(
            slot='spinner'
            :size='30'
            :color='`#b1b1b1`')
        div.infinite-scroll-slot(slot='no-more' style='padding-top: 15px;')
          span.infinite-scroll-slot-noMore 沒有更多資料
        div.infinite-scroll-slot(slot='no-results' style='padding-top: 15px;')
          span.infinite-scroll-slot-noMore 沒有更多資料

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  putUserLoadAnalysis,
} from '../../../js/restapi';
import IconLoading from '../../icon/Loading';
import IconSearch from '../../icon/Search';
import GlobalEmitter from 'tiny-emitter/instance';

export default {
  components: {
    IconLoading,
    IconSearch,
  },

  created() {
    this.axiosLoadAnalysisHistory();
    this.detectGlobalEmitter();
  },

  data() {
    return {
      showLoading: true,
      analysisData: [],
      analysisEmpty: false,
      pageSize: 10,
      pageIndex: 1,

      infiniteId: new Date(),
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopAnalysisStatus: 'global/POPANALYSIS_STATUS',
    }),

    infiniteHandler($state) {
      if (!this.showLoading) {
        const USER_CONFIG = {
          auth_id: this.loginDjangoId,
          page: this.pageIndex,
          size: this.pageSize,
          // category: 'analysis'
        };

        putUserLoadAnalysis('', USER_CONFIG)
          .then((res) => {
            res.data.results.map((x) => {
              this.analysisData.push({
                start_date: x.start_date,
                end_date: x.end_date,
                category: x.category,
                broadcast: x.broadcast,
                reminder: x.reminder,
                prediction: x.prediction,
                suggestion: x.suggestion,
                course: x.course,
                summary: x.summary ? JSON.parse(x.summary.replace(/'/g, '"')) : '',
                vertex_source: x.vertex_source ? JSON.parse(x.vertex_source.replace(/'/g, '"')) : '',
                // tag: x.tag ? JSON.parse(x.tag.replace(/'/g, '"')) : '',
              });
            });

            if (res.data.results.length < this.pageSize || this.analysisData.length === res.data.count) {
              $state.complete();
            } else {
              this.pageIndex += 1;
            }
            $state.loaded();
          })
          .catch((err) => {
            console.log('err', err);
          })
      } else {
        $state.complete();
      }
    },

    detectGlobalEmitter() {
      let vm = this;
      GlobalEmitter.on('reload-analysis', (arg) => {
        vm.axiosLoadAnalysisHistory();
      });
    },

    axiosLoadAnalysisHistory() {
      this.analysisData = [];
      this.pageIndex = 1;

      const USER_CONFIG = {
        auth_id: this.loginDjangoId,
        page: this.pageIndex,
        size: this.pageSize,
        // category: 'analysis'
      };

      putUserLoadAnalysis('', USER_CONFIG)
        .then((res) => {
          console.log('res', res.data);

          if (!res.data.count) {
            this.analysisEmpty = true;
          } else {
            // this.analysisData = res.data.results;
            res.data.results.map((x) => {
              this.analysisData.push({
                id: x.id,
                evaluate: x.evaluate,
                start_date: x.start_date,
                end_date: x.end_date,
                category: x.category,
                broadcast: x.broadcast,
                reminder: x.reminder,
                prediction: x.prediction,
                suggestion: x.suggestion,
                course: x.course,
                summary: x.summary ? JSON.parse(x.summary.replace(/'/g, '"')) : '',
                vertex_source: x.vertex_source ? JSON.parse(x.vertex_source.replace(/'/g, '"')) : '',
                // tag: x.tag ? JSON.parse(x.tag.replace(/'/g, '"')) : '',
              });
            })
            console.log('putUserLoadAnalysis Success', this.analysisData);
            this.pageIndex += 1;
          }
          this.showLoading = false;
          this.infiniteId += 1;
        })
        .catch((err) => {
          console.log('err', err);
          this.changePopBoxStatus({
            active: true,
            include: 'warnError',
          });
        })
    },

    handleClickShowAnalysisDetail(input) {
      console.log('handleClickShowAnalysisDetail', input.vertex_source);
      this.changePopAnalysisStatus({
        active: true,
        detail: {
          id: input.id,
          evaluate: input.evaluate,
          start_date: input.start_date,
          end_date: input.end_date,
          category: input.category,
          broadcast: input.broadcast,
          reminder: input.reminder,
          prediction: input.prediction,
          suggestion: input.suggestion,
          course: input.course,
          summary: input.summary,
          vertex_source: input.vertex_source,
        },
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      // loginStatus: 'user/exportLoginStatus',
      // subscribeVip: 'user/exportUserSubscribeVip',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectAnalysis.scss';
</style>
